import { STATUS_COLORS, PRIORITY_COLORS } from "@/constants";

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId || `status-badge-${status?.toLowerCase().replace(/\s/g, "-")}`}
    className="inline-flex items-center gap-1.5 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide"
    style={{ borderRadius: "2px", color: STATUS_COLORS[status] || "#64748b", border: `1px solid ${STATUS_COLORS[status] || "#64748b"}30`, background: `${STATUS_COLORS[status] || "#64748b"}14` }}
  >
    <span className="w-1.5 h-1.5 rounded-full" style={{ background: STATUS_COLORS[status] || "#64748b" }} />
    {status}
  </span>
);

export const PriorityBadge = ({ priority, testId }) => (
  <span
    data-testid={testId || `priority-badge-${priority?.toLowerCase()}`}
    className="inline-flex items-center px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide"
    style={{ borderRadius: "2px", color: PRIORITY_COLORS[priority] || "#64748b", border: `1px solid ${PRIORITY_COLORS[priority] || "#64748b"}30`, background: `${PRIORITY_COLORS[priority] || "#64748b"}14` }}
  >
    {priority}
  </span>
);
